<template>
    <div>
        <NavigationBar></NavigationBar>

        <div class="d-flex align-items-center">
            <div class="p-0 flex-grow-1 ms-3">
                <UserInformationCard></UserInformationCard>
            </div>
            <div class="align-items-center">
                <div class="m-3">
                    <UpdatePassword/>
                </div>
                <div class="m-3">
                    <DashboardFilter/>
                </div>
            </div>
        </div>

        <DashboardCompliance></DashboardCompliance>
        <FooterView></FooterView>
    </div>
</template>
<script>
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import UserInformationCard from '@/components/home/User-information-card.vue';

import DashboardCompliance from '@/components/home/Dashboard-compliance.vue';
import DashboardFilter from '@/components/home/Dashboard-filter.vue';
import FooterView from '@/components/shared/Footer/Footer-view.vue';
import UpdatePassword from '@/components/home/Update-Password.vue';

export default {
    name: 'HomeViews',

    components: {
        NavigationBar,
        UserInformationCard,
        DashboardCompliance,
        DashboardFilter,
        UpdatePassword,
        FooterView
    },

    computed: {
    },
}
</script>
<style scoped></style>